'use strict';
var TEN_YEARS_IN_SECONDS, setSiteCookies;

TEN_YEARS_IN_SECONDS = 60 * 60 * 24 * 365 * 10;

module.exports = setSiteCookies = function(cookies, seconds) {
  var cookieDomain, key, results, val;
  if (seconds == null) {
    seconds = TEN_YEARS_IN_SECONDS;
  }
  cookieDomain = setSiteCookies.cookieDomain || (setSiteCookies.cookieDomain = $('head').data('domain'));
  results = [];
  for (key in cookies) {
    val = cookies[key];
    if (val != null) {
      results.push(Cookie.set(key, val, seconds, cookieDomain));
    } else {
      results.push(Cookie.unset(key, cookieDomain));
    }
  }
  return results;
};

